var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v("Copyright©"+_vm._s(_vm.year)+"途陽国際株式会社所有权利")])
}
var staticRenderFns = []

export { render, staticRenderFns }